import { AlertCircle } from "lucide-react";

const DirtyCheckPrompt = ({
    visible,
    message = "Any unsaved changes will be lost.",
    onConfirm,   // Save
    onCancel,    // Cancel
    onDisregard, // Disregard
}) => {
    if (!visible) return null;

    return (
        <div
            className="fixed inset-0 z-[2147483647] flex items-start justify-center 
                       bg-black/60 transition-all duration-300"
        >
            <div
                className="mt-2 bg-white rounded-md shadow-xl w-[400px] max-w-[90%] p-6 text-left"
            >
                {/* Header with icon */}
                <div className="flex items-center mb-2">
                    <AlertCircle className="text-red-500 w-5 h-5 mr-2" />
                    <h3 className="font-semibold text-gray-900 text-base">
                        Save changes before continuing
                    </h3>
                </div>

                {/* Message text */}
                <p className="text-gray-700 text-sm mb-5">{message}</p>

                {/* Buttons */}
                <div className="flex justify-end gap-2">
                    <button
                        onClick={onCancel}
                        className="px-4 py-1.5 border border-gray-300 rounded-md bg-gray-100 hover:bg-gray-200 text-sm font-medium"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onDisregard}
                        className="px-4 py-1.5 border border-gray-300 rounded-md bg-gray-100 hover:bg-gray-200 text-sm font-medium"
                    >
                        Disregard
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-5 py-1.5 rounded-md bg-[#1E79C2] hover:bg-[#16649E] text-white text-sm font-medium"
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DirtyCheckPrompt;
